import Service from "../../services";

const Auth = {
  namespaced: true,
  state: {
    user: null,
    accessToken: null,
    registerToken: null,
  },
  mutations: {
    SET_TOKEN: (state, data) => {
      state.accessToken = data.token;
      state.user = data.user;
    },

    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_TOKEN_REGISTER: (state, token) => {
      state.registerToken = token;
    },
      RESET_STATE: (state) => {
      state.user = null;
      state.accessToken = null;
    },
  },
  actions: {
    login({commit}, data) {
      return Service.Auth.login(data)
        .then(data => {
          // console.log(data)
          commit("SET_TOKEN", data.success);
          return data;
        })
        .catch(err => {
          return Promise.reject(err)
        })
    },
    register({commit}, data) {
      return Service.Auth.register(data).then(data => {
        commit("SET_TOKEN_REGISTER", data.success.token);
        return data;
      });
    },
    setUser({commit}) {
      return Service.Auth.getUser().then(data => {
        commit("SET_USER", data)
      }).catch(err => Promise.reject(err));
    },

    editUser({commit}, data) {
      return Service.Auth.editUser(data).then(data => {
        commit("SET_USER", data)
      }).catch(err => Promise.reject(err))
    },

    changePassword({commit},data) {
      // console.log(data)
      return Service.Auth.changePassword(data).then(data => {
        // console.log(data)
        commit(data)
      }).catch(err => {
        // console.log(Promise.reject(err))
        return Promise.reject(err)
      })
    },

    logout({commit}) {
      commit("RESET_STATE");
      // commit("SET_TOKEN", null);
    },
    checkEvaluation({commit},id) {
      return Service.Auth.checkEvaluation(id);
    },
    evaluation({commit},data) {
      return Service.Auth.evaluation(data);
    },
    requestResetPassword({commit}, email) {
      return Service.Auth.requestResetPassword(email);
    },
    resetPassword({commit}, data) {
      return Service.Auth.resetPassword(data);
    },
    getEmailFromToken({commit}, token) {
      return Service.Auth.getEmailFromToken(token);
    }
  }
};

export default Auth;
